import { ServiceItem } from '../types';
import { isFlatRateService } from './flatRateLogic';

export type ServiceTileType = 'vorank' | 'unterlage' | 'sigeplan' | 'asplan' | 'inspection' | 'einweisung' | 'planning_general' | 'site_rules';

/**
 * Gehoert eine LV-Position zu einer Kachel des Projekt-Hubs?
 *
 * Die Zuordnung am LV-Posten (`assignment`) ist die erste Quelle. Die
 * Textarme fangen den Altbestand ohne Zuordnung ab und gelten NUR fuer die
 * vier alten Kacheln — 'einweisung' hat bewusst KEINEN Textarm: ein
 * Stichwort „einweisung" im Titel trifft sonst die Begehungsposition
 * „Einweisung der Nachunternehmer" mit, und die Kachel zeigte das
 * Begehungskontingent an. 'asplan' aus demselben Grund nicht — "Plan",
 * "A+S" oder "Sicherheitsplan" treffen die SiGe-Plan-Position direkt daneben.
 *
 * Eine Funktion fuer den Zaehler (calculateStats) UND die Aktivitaetszeile
 * (moduleActivity): beide muessen dieselben Positionen meinen.
 *
 * Eine Monatspauschale ist nie vom Typ 'inspection' — weder ueber die
 * Zuordnung noch ueber Titel („Begehung") oder LV-Nummer (2.7./2.8.): ihre
 * Mengen sind MONATE. Ihre Nachweiszeilen (Begehungen im Pauschalprojekt)
 * rechnen die Aufrufer ueber projectLv.inspectionProofCount/-Matcher hinzu.
 */
export const istLeistungVomTyp = (s: ServiceItem, type: ServiceTileType): boolean =>
    !(type === 'inspection' && isFlatRateService(s)) && (
    s.assignment === type ||
    (type === 'inspection' && (s.lvPosition?.startsWith('2.7.') || s.lvPosition?.startsWith('2.8.') || s.title.toLowerCase().includes('begehung'))) ||
    (type === 'vorank' && (s.lvPosition?.startsWith('2.1.') || s.title.toLowerCase().includes('vorank'))) ||
    (type === 'unterlage' && (s.lvPosition?.startsWith('1.4.') || s.title.toLowerCase().includes('unterlage'))) ||
    (type === 'sigeplan' && (s.lvPosition?.startsWith('1.2.') || s.title.toLowerCase().includes('sigeplan'))) ||
    false);
